import { toast } from "sonner";

import type {
  ToastOptionsDto,
  ToastServicePort,
} from "@/application/records/ports/ToastServicePort";

/**
 * Infrastructure adapter: обертка вокруг UI-тостов для Records.
 */
export class RecordsToastNotificationService implements ToastServicePort {
  success(message: string, options?: ToastOptionsDto): void {
    toast.success(message, options);
  }

  error(message: string, options?: ToastOptionsDto): void {
    toast.error(message, options);
  }
}
